import { render } from "./NotificationCard.vue?vue&type=template&id=2bd6bf86&lang=pug"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/notification/NotificationCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bd6bf86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bd6bf86', __exports__)) {
    api.reload('2bd6bf86', __exports__)
  }
  
  module.hot.accept("./NotificationCard.vue?vue&type=template&id=2bd6bf86&lang=pug", () => {
    api.rerender('2bd6bf86', render)
  })

}


export default __exports__